export default __webpack_public_path__ + "static/media/ARBook.0e4ef234916176ff81738810d80d824f.webp";